import { DELETE_HOW_TO_APPLY_ERROR, DELETE_HOW_TO_APPLY_START, DELETE_HOW_TO_APPLY_SUCCESS } from '../../types';

export default function delete_how_to_apply(state, action) {
  switch (action.type) {
    case DELETE_HOW_TO_APPLY_START:
      return { ...state };
    case DELETE_HOW_TO_APPLY_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case DELETE_HOW_TO_APPLY_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}